/* reason: the prop-types flow seems not to work with classes */
/* eslint-disable react/prop-types */
import { Component, FC } from 'react'
import { connect } from 'formik'
import isEqual from 'lodash/isEqual'
import debounce from 'lodash/debounce'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export class FieldEffectComponent extends Component<any> {
  // eslint-disable-next-line react/state-in-constructor
  state = {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
    onChange: (event: any) => {},
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(props: any) {
    super(props)
    this.state = {
      onChange: debounce(props.onChange, 300),
    }
  }

  // @ts-expect-error
  componentDidUpdate({ formik: prevFormik }) {
    const { select, formik, validationSchema } = this.props
    const { onChange } = this.state

    const value = select(formik.values)
    const prevValue = select(prevFormik.values)

    if (!isEqual(value, prevValue)) {
      if (validationSchema) {
        validationSchema.isValid(value).then((isValid: boolean) => {
          if (isValid) {
            onChange({ value, values: formik.values })
          }
        })
      } else {
        onChange({ value, values: formik.values })
      }
    }
  }

  render() {
    return null
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- explicit type annotation is needed here, otherwise the Bazel build fails
export const FieldEffect: FC<any> = connect(FieldEffectComponent)
